import { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import HttpAPICall from '../../services/HttpAPICall';
import TapIcon from '../../services/TapIcon';
import ApplicationLayout from '../../layouts/ApplicationLayout';
import { DisplayListPagination, DisplaySearchCriteria } from '../../components/TapUi';
import Loader from '../../components/ui/Loader/Loader';
import { BACKOFFICE_BASE_URL } from '../../services/TapApiUrls';
import Status from '../../components/ui/Status';
import ChangeAssetCounterLogMeter from '../asset/ChangeAssetCounterLogMeter/ChangeAssetCounterLogMeter';
import GroupCard from './GroupCard';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { toast } from 'react-toastify';
import GroupDetail from './GroupDetail';
import UpdateLicenseModal from './UpdateLicenseModal';

const NewGroupList = ({ history }) => {
        const licenseModalRef                 =       useRef(null);
    
    const access_token          =   useSelector(state => state.auth.access_token);
    const permissions           =   useSelector(state => state.app.acl_info?.permissions || []);
    
    const [listingLoading, setListingLoading]           = useState(false);
    const [groupListing, setGroupListing]               = useState([]);
    const [listingMeta, setListingMeta]                 = useState(null);
    const [minimizeTable, setMinimizable]               = useState(false);
    const [showAssetMeter, setShowAssetMeter]           = useState(false);
    const [detail_loading, setDetail_loading]           = useState(false);
    const [groupDetail, setGroupDetail]                 = useState(null);
    const [iamLicenceDetail, setIamLicenceDetail]       = useState(null);
    const [hrmLicenceDetail, setHrmLicenceDetail]       = useState(null);
    const [iscLicenceDetail, setIscLicenceDetail]       = useState(null);
    const [selectedGroup, setSelectedGroup]       = useState(null);



    



    useEffect(() => {
        loadListingTblData(1);
    }, []);

    const loadListingTblData = (page = 1) => {
        setListingLoading(true);
        const params = { page: page, per_page: 100 };
        HttpAPICall.withAthorization('GET', BACKOFFICE_BASE_URL + '/group/list', access_token, params, {}, (resp) => {
            const respData = resp.data;
            setGroupListing(respData.data);
            setListingMeta({
                from: respData.from,
                to: respData.to,
                total: respData.total,
                last_page: respData.last_page,
                per_page: respData.per_page,
                current_page: respData.current_page
            });
        }).then(() => setListingLoading(false));
    };


    const viewGroupDetail = (item) => {

        // if(permissions.includes('group-license-view')){
            setMinimizable(true);
            setShowAssetMeter(false);
            setSelectedGroup(item)

            // getGroupDetail(id)
        // }else{
        //     toast.info("Sorry You dont have permission", { position: toast.POSITION.TOP_RIGHT });
        // }
    };

    const getGroupDetail                   =      (id)    =>       {
        setDetail_loading(true)
        HttpAPICall.withAthorization('GET',  process.env.REACT_APP_SERVER_PATH + '/backoffice/group/detail/' + id, access_token, {}, {}, (resp) => {
            let respData                    =       resp.data;
            let detail                      =       respData && respData.data ? respData.data : null;
            let iam_licence_detail          =       detail && detail.iam_licence ? detail.iam_licence : null;
            let hrm_licence_detail          =       detail && detail.hrm_licence ? detail.hrm_licence : null;
            let isc_licence_detail          =       detail && detail.isc_licence ? detail.isc_licence : null;
            setGroupDetail(respData.data)
            setIamLicenceDetail(iam_licence_detail)
            setHrmLicenceDetail(hrm_licence_detail)
            setIscLicenceDetail(isc_licence_detail)
        }).then(() => setDetail_loading(false));
    }
    

    const closeViewDetails = () => {
        setMinimizable(false);
        setShowAssetMeter(false);
    };

    const handleAssetMeter = () => {
        // if (groupDetail) {
            setMinimizable(false);
            setShowAssetMeter(true);
        // }
    };
    const updateLicenseModal = () => {
        if (licenseModalRef.current) {
            licenseModalRef.current.initModalHandler();
        }
    };
    const handleAssetMatrix = () => {
        history.push({
            pathname: `/change_asset_matrix`,
           
            
            state: { selectedGroup: selectedGroup }
        });
         console.log(groupListing);
    };

    const groupJsx = () => {
        return (
            <>
                <div className="page_title row m0">
                    {!showAssetMeter &&
                        <div className={minimizeTable ? "col-3" : "col-12"}>
                            {<h3>Group List</h3>}
                            <div className="text-end mt15">
                                {(!minimizeTable) ? <></> : null}
                            </div>
                        </div>}
                    <div className={[minimizeTable ? 'col-9 tap_border_left' : 'col-12'].join(' ')}>
                        <h3>
                            {minimizeTable ? `Group: ${selectedGroup?.group_name || ''}` :
                                `Group: ${selectedGroup?.group_name || ''}`}
                        </h3>
                        <div className="text-end mt15 ">
                            {minimizeTable && (<>
                                <span className="dropdown">
                                    <button
                                        type="button"
                                        id='actionMenuButton'
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        className="btn btn-secondary"
                                    >
                                        Action
                                    </button>
                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                        <>
                                        {/* <li><button onClick={updateLicenseModal} className='dropdown-item' >Update Details</button></li> */}
                                         {permissions.includes('change_group_asset_counterlog_meter') && 
                                        <><li><button onClick={handleAssetMeter} className='dropdown-item' >Counterlog Configuration</button></li></>
                                         } 
                                        {permissions.includes('change_group_asset_counterlog_meter') && 
                                        <><li><button onClick={handleAssetMatrix} className='dropdown-item' >Change Asset Matrix</button></li></>
                                         }  
                                        </>
                                    </ul>
                                </span>
                                <button type="button" className="btn btn-secondary" data-bs-toggle="dropdown" role="button" aria-expanded="false">
                                    <TapIcon.FontAwesomeIcon icon={TapIcon.faHistory} className="img-fluid mr3" alt="item-action" />
                                    History</button>
                                <ul className="dropdown-menu dropdown-menu-end" style={{ cursor: "pointer" }}>
                                    <li>
                                        <Link className="dropdown-item" 
                                        // to={{ pathname: `/asset_matrix_listing` }}
                                        >
                                        Asset Matrix
                                        </Link>
                                        </li>
                                    {/* <li><Link className="dropdown-item" to={{ pathname: `/counterlog_listing` }}>CounterLog</Link></li> */}
                                </ul>
                              
                            </>

                            )}
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={closeViewDetails}
                            >
                                <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="item-close" />
                            </button>
                        </div>
                    </div>

                </div>
                <div className="container-fluid pl5">
                    {showAssetMeter && (
                        <div className="page_containt row">
                            <div className="bg-white col-9 pl4" style={{ height: "100%" }}>
                                {assetMeterJsx()}
                            </div>
                            <div className='col-3 pl4 pe-2  page_containt' style={{ top: "0px" }}>
                                <GroupCard groupListing={selectedGroup} />
                            </div>
                        </div>
                    )}
                    {!showAssetMeter && <div className="page_containt row">
                        <div className={['pageTbl', (minimizeTable) ? 'col-3' : 'col-12'].join(' ')}>
                            {groupListingJsx()}
                        </div>
                        {minimizeTable && (
                            <div className="col-9 pr4 pl4">
                                <div className="bg-white p-2" style={{ height: "100%" }}>
                                    <GroupDetail  groupDetail={selectedGroup} detail_loading ={detail_loading} />
                                </div>
                            </div>
                        )}
                    </div>}
                </div>
            </>
        );
    };

    const assetMeterJsx = () => {
        return (
            <section className="item_view_container bg-white pageTbl ">
                <ChangeAssetCounterLogMeter master_id={selectedGroup.master_id} />
            </section>
        );
    };
 
    const groupListingJsx = () => {
        return (
            <>
                <table className="table table-bordered table-fixed bg-white table-sm">
                    <thead className="table-secondary">
                        <tr className='text-center'>
                            {minimizeTable || showAssetMeter
                                ? <th scope="col">Name</th>
                                : <>
                                    <th scope="col" style={{ width: "5%" }}>S.No</th>
                                    <th scope="col" style={{ width: "10%" }}>Group ID</th>
                                    <th scope="col" style={{ width: "26%" }}>Name</th>
                                    <th scope="col" style={{ width: "18%" }}>IAM License</th>
                                    <th scope="col" style={{ width: "18%" }}>HRM License</th>
                                    <th scope="col" style={{ width: "18%" }}>ISC License</th>
                                    <th scope="col" className="text-center" style={{ width: "5%" }}>Action</th>
                                </>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {listingLoading
                            ? <tr><td colSpan="7"><Loader /></td></tr>
                            : (groupListing && groupListing.length > 0
                                ? (groupListing.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            {minimizeTable || showAssetMeter
                                                ? <td className='cursor_pointer link-primary' onClick={() => viewGroupDetail(item)}>
                                                    {item.group_name || "-"}
                                                </td>
                                                : <>
                                                    <td className='text-center'>{listingMeta ? listingMeta.from + index : index}</td>
                                                    <td className='text-center'>{item.master?.tap_master_id || "-"}</td>
                                                    <td className='cursor_pointer link-primary' onClick={() => viewGroupDetail(item)}>
                                                        {item.group_name || "-"}
                                                    </td>
                                                    <td className='text-center'>
                                                        {item.iam_licence ? (
                                                            <Status color={item.iam_licence.status_color_code}>
                                                                {item.iam_licence.status_text} ({item.iam_licence.licence_to_display})
                                                            </Status>
                                                        ) : "-"}
                                                    </td>
                                                    <td className='text-center'>
                                                        {item.hrm_licence ? (
                                                            <Status color={item.hrm_licence.status_color_code}>
                                                                {item.hrm_licence.status_text} ({item.hrm_licence.active_till_display})
                                                            </Status>
                                                        ) : "-"}
                                                    </td>
                                                    <td className='text-center'>
                                                        {item.isc_licence ? (
                                                            <Status color={item.isc_licence.status_color_code}>
                                                                {item.isc_licence.status_text} ({item.isc_licence.active_till_display})
                                                            </Status>
                                                        ) : "-"}
                                                    </td>
                                                    <td className='text-center'>
                                                        <TapIcon.imageIcon
                                                            icon={TapIcon.ListActionIcon}
                                                            alt="action-icon"
                                                            className="img-fluid px-3"
                                                            data-bs-toggle="dropdown"
                                                            href="#"
                                                            role="button"
                                                            aria-expanded="false"
                                                        />
                                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                            <li>
                                                                <button
                                                                    className="dropdown-item"
                                                                    onClick={() => viewGroupDetail(item)}
                                                                >
                                                                    View
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </>
                                            }
                                        </tr>
                                    )
                                }))
                                : (<tr><td colSpan="7" className="text-center">No Records</td></tr>)
                            )}
                    </tbody>
                </table>
                <DisplayListPagination
                    meta={listingMeta}
                    onPageChange={(e) => loadListingTblData(e.selected + 1)}
                />
            </>
        )
    };

    return (
        <ApplicationLayout>
            <Helmet><title>New Group Listing</title></Helmet>
            {groupJsx()}
            <UpdateLicenseModal ref={licenseModalRef}  groupDetail={groupDetail}
            // onSearch={handleSearch}
            //     initialSearchForm={submittedModelFilterForm} 
                />
        </ApplicationLayout>
    );
};

export default NewGroupList;